(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babylonjs"), require("babylonjs-materials"), require("babylonjs"));
	else if(typeof define === 'function' && define.amd)
		define("babylonjs-node-particle-editor", ["babylonjs", "babylonjs-materials", "babylonjs"], factory);
	else if(typeof exports === 'object')
		exports["babylonjs-node-particle-editor"] = factory(require("babylonjs"), require("babylonjs-materials"), require("babylonjs"));
	else
		root["NODEPARTICLEEDITOR"] = factory(root["BABYLON"], root["BABYLON"], root["BABYLON"]["Debug"]);
})((typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this), (__WEBPACK_EXTERNAL_MODULE__5597__, __WEBPACK_EXTERNAL_MODULE__4208__, __WEBPACK_EXTERNAL_MODULE__5992__) => {
return 